// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3vUqt","rootSuccess":"CompleteLink_rootSuccess__36Eh4","rootFailure":"CompleteLink_rootFailure__2Jtkj","isDisabled":"CompleteLink_isDisabled__PsdtI"};